import { Link, useLocation } from 'react-router';
import { cn, VisuallyHidden } from '@ircf/ui';
import { pathwayFor, pathwayForPath } from '@ircf/config';
import { useContent } from '../../app/content.js';
import { accentTextClass } from '../../lib/pathway.js';

export function BrandLockup({ className }: { className?: string }) {
  const location = useLocation();
  const content = useContent();
  const identity = pathwayFor(pathwayForPath(location.pathname));

  return (
    <Link
      to="/"
      className={cn(
        'group flex min-w-0 items-center gap-3 rounded-sm focus-visible:outline-2 focus-visible:outline-offset-4 focus-visible:outline-warm-white',
        className,
      )}
    >
      <img
        src={content.business.logoUrl}
        alt=""
        width={48}
        height={48}
        decoding="async"
        className="size-11 shrink-0 object-contain sm:size-12"
      />
      <span className="flex min-w-0 flex-col leading-tight">
        <span className="truncate text-sm font-semibold tracking-wide text-warm-white sm:text-base">
          {content.business.name}
        </span>
        <span
          className={cn(
            'mt-0.5 text-[0.65rem] font-medium tracking-[0.16em] uppercase sm:text-xs',
            accentTextClass(identity.id),
          )}
        >
          {identity.wordmark.anchor} {identity.wordmark.qualifier}
        </span>
      </span>
      <VisuallyHidden>
        {content.business.name} - {identity.label}. Return to the homepage.
      </VisuallyHidden>
    </Link>
  );
}
